<!--
* UIID: UI-Caas-PTN-100
* UI Name: Parnert Card List
* Modify Date: 2020/06/17
-->
<template>
  <div>
    <!-- Condition search -->
    <v-row class="custom-form-control data-query-section custom-figma-1 mb-0">
      <!--203737 Change the font size of ""Select Status"" to 14px -->
      <v-col cols="12" sm="4" md="3" lg="3" xl="2" class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1">
        <v-text-field
          v-model="searchPartner"
          :label="$t('lbl.common.conditionSearch.findbyPartner')"
          class="custom-selectbox"
          dense      
          filled
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="3" xl="2" class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1">
        <v-autocomplete
          v-model="searchStatus"
          :label="$t('lbl.common.conditionSearch.selectStatus')"
          :items="stsCdList"
          class="custom-selectbox"
          dense
          filled
        ></v-autocomplete>
      </v-col>
    </v-row>
    <!-- Card Detail -->
    <v-row class="grid-parner-content">
      <v-col
        v-for="item in getListData"
        :key="item.id"
        v-show="(searchStatus == null || searchStatus == '' || searchStatus == item.stsCd) && findSearchPartner(item)"
        class="card-padding"
        cols="12"
        sm="6"
        md="3"
        lg="3"
        xl="2"
      >
        <partnerDetail :detail="item" @refresh="refreshList()"></partnerDetail>
      </v-col>

      <v-col cols="12" sm="6" md="3" lg="3" xl="2" :class="inputDisplay" class="card-padding">
        <v-card class="p-2 font-light partner-card-container" :color="getGreyColor()">
          <v-form ref="form" lazy-validation autocomplete="off" class="partner-grid-form">
            <v-row class="custom-form-control ml-0 mr-0">
              <v-col cols="12" class="pa-0">
                <v-text-field
                  v-model="insertItem.prnrNm"
                  :error-messages="formError.name.message"
                  :placeholder="$t('lbl.partners.partnerName')"
                  :autofocus="true"
                  :rules="[validationUtils.required, validationUtils.max(50)]"
                  solo
                  outlined
                  ref="prnrNm"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="custom-form-control ml-0 mr-0">
              <v-col cols="12" class="pa-0">
                <v-text-field
                  v-model="insertItem.cnttPrn"
                  ref="cnttPrn"
                  :error-messages="formError.name.message"
                  :placeholder="$t('lbl.partners.contactPersonName')"
                  :rules="[validationUtils.required, validationUtils.max(100)]"
                  solo
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="custom-form-control ml-0 mr-0">
              <v-col cols="12" class="pa-0">
                <v-text-field
                  v-model="insertItem.email"
                  ref="email"
                  @blur="checkPartner()"
                  :error-messages="formError.name.message"
                  :placeholder="$t('lbl.partners.emailAddress')"
                  :rules="[validationUtils.required, validationUtils.emailRules, validationUtils.max(100)]"
                  solo
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="custom-form-control ml-0 mr-0">
              <v-col cols="12" class="pa-0">
                <v-text-field
                  v-model="insertItem.remark"
                  ref="remark"
                  :error-messages="formError.name.message"
                  :placeholder="$t('lbl.partners.remark')"
                  :rules="[validationUtils.required, validationUtils.max(200)]"
                  outlined
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="custom-form-control ml-0 mr-0">
              <v-col cols="5" lg="1" md="1" class="pt-0 pb-0 pl-0">
                <v-btn class="btn" text icon @click="closeInput()">
                  <v-icon small>fa fa-times</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="7" lg="11" md="11" class="pt-0 pb-0 pr-0">
                <div class="text-right">
                  <v-btn
                    class="btn btn-search"
                    @click="addPartner()"
                    :disabled="!$auth.manage || !checkComplete"
                    color="primary"
                  >{{$t('lbl.partners.addPartner')}}</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2" class="card-padding" v-show="$auth.manage">
        <v-card class="p-2 font-light" :color="getGreyColor()">
          <v-row dense>
            <v-col cols="12" class="text-sm">
              <v-btn text small @click="openInput" class="add-antr-partner">
                <v-icon x-small class="mr-1">fa fa-plus</v-icon>
                {{$t('lbl.partners.addAnotherPartner')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <dialogWindow
      ref="AlertPartner"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="alertPrnrClose()"
    ></dialogWindow>
  </div>
</template>

<script>
import partnerDetail from '@/vue-caas/views/partner/PartnerCardDetail.vue'
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

  export default {
    components: {
      partnerDetail,
      dialogWindow,
    },

    props: {
      items: {
        default: [],
      },
    },

    data(){
      return{
      listData: [],
      insertItem: {
        prnrNm: '',
        cnttPrn: '',
        email: '',
        emailF: '',
        emailT: '',
        stsCd: '',
        remark: '',
      },
      formError : {
        name : {
          message : ''
        }
      },
      searchPartner: '',
      searchStatus: null,
      stsCdList: [
        {text: this.$t('lbl.common.conditionSearch.all'), value: ''},
        {text: 'Confirmed', value: 'C'},
        {text: 'Waiting Confirmation', value: 'W'},
        {text: 'Not Send Email', value: 'N'},
      ],
      inputDisplay: "d-none",
      checkBtnColor: 'secondary',
      checkBtnIcon: 'fa fa-question',
      checkBtnTitle: 'Do not checked.',
      checkDialog: false,
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      rules: {
        prnrNm: [
          v => !!v || 'Partner Name Address is required',
          v => !v || v.length <= 50 || 'Partner Name max length is 50.',
        ],
        cnttPrn: [
          v => !!v || 'Contact Person is required',
          v => !v || v.length <= 100 || 'Contact Person max length is 100.',
        ],
        email: [
          v => !!v || 'Partner Email Address is required',
          v => !v || v.length <= 100 || 'Partner Email Address max length is 100.',
          v => /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i.test(v) || 'Email Address must be valid',
          v => !checkDupResult || 'Partner is duplicated.'
        ],
        remark: [
          v => !v || v.length <= 200 || 'Remark max length is 200.',
        ],
      },
      formHasErrors: false,
      checkDupResult: true,
      checkComplete: true,
    }},

    computed: {
      getListData() {
        return this.listData;
      },
      formData() {
        return {
          prnrNm: this.insertItem.prnrNm,
          cnttPrn: this.insertItem.cnttPrn,
          email: this.insertItem.email,
          remark: this.insertItem.remark,
        }
      },
    },

    methods: {
      initInsertItem() {
        this.insertItem = {
          prnrNm: '',
          cnttPrn: '',
          email: '',
          emailF: '',
          emailT: '',
          stsCd: '',
          remark: '',
        };
      },
      setFieldValidation(name, message) {
        this.formError[name] = {
          message
        };
      },

      openInput() {
        this.inputDisplay = "";
      },

      closeInput() {
        this.inputDisplay = "d-none";
        this.initInsertItem();
      },

      addPartner() {
        this.formHasErrors = false;

        Object.keys(this.insertItem).forEach(key => {
          if (this.$refs[key] !== undefined) {
            if (!this.formData[key] || this.formData[key] === '') this.formHasErrors = true;

            this.$refs[key].validate(true);
          }
        });

        if (!this.formHasErrors) {
          if(!this.checkDupResult) {
            this.$store.dispatch('insertPartner', this.insertItem).then(() => {
              this.listData = this.$store.getters.partnerList;
              this.initInsertItem();
              this.inputDisplay = "d-none";
              this.setCheckStatus();
              this.$refs.AlertPartner.dialog = true;
              this.checkDialogColor = 'success';
              this.checkDialogInfo = this.$t('msg.partners.saveAdditionalPartner');
            });
          } else if (this.checkDupResult) {
            this.$refs.AlertPartner.dialog = true;
            this.checkDialogColor = 'error';
            this.checkDialogInfo = 'Partner e-mail domain is duplicated.';
          }
        }
      },

      /* 203665 Remove unuse code
      clickListIcon(event) {
        this.$emit("click-list-icon", event);
      }, */

      getGreyColor() {
        let theme = this.$vuetify.theme.dark ? 'dark' : 'light';
        return 'grey ' + theme + 'en-4';
      },

      refreshList() {
        this.listData = this.$store.getters.partnerList;
      },

      findSearchPartner(item) {
        if(this.searchPartner != '') {
          if(item['prnrNm'].toLowerCase().indexOf(this.searchPartner.toLowerCase()) > -1) {
            return true;
          }
          return false;
        } else {
          return true;
        }
      },

      checkPartner() {
        this.checkComplete = false;
        if (this.insertItem.email.length > 0) {
          this.$store.dispatch('checkPartner', this.insertItem).then(() => {
            const tmp = this.$store.getters.partnerCheckResult;
            if (tmp.prnrId === undefined) {
              this.checkDupResult = false;
            } else {
              this.checkDupResult = true;
            }

            this.checkComplete = true;
          });
        }
      },

      setCheckStatus(val) {
        if (val === 'S') {
          this.checkBtnColor = 'success';
          this.checkBtnIcon = 'fa fa-check';
          this.checkBtnTitle = 'Usable this e-mail';
        } else if (val === 'E') {
          this.checkBtnColor = 'error';
          this.checkBtnIcon = 'fa fa-times';
          this.checkBtnTitle = 'Duplicated';
        } else {
          this.checkBtnColor = 'secondary';
          this.checkBtnIcon = 'fa fa-question';
          this.checkBtnTitle = 'Do not checked';
        }
      },

      alertPrnrClose() {
        this.$refs.AlertPartner.dialog = false;
      }
    },

    created() {
      this.listData = this.items;
    },

  }
</script>
<style scoped>
  .grid-parner-content{
    max-height: 730px;
    overflow-y: auto;
  }
  .card-padding{
    padding-top:0;
    padding-bottom: 0;
    margin-bottom: 30px;
    padding-right: 18px;
  }
  /* Theme-light */
  .theme--light .partner-card-container{
    background: linear-gradient(to top right,transparent 50%,#ffffff 0) top right/25px 26px no-repeat,
    linear-gradient(to bottom left,transparent 50%,#ffffff 0) bottom left/25px 26px no-repeat, #ffffff;
  }
  .theme--light>>> button.add-antr-partner span.v-btn__content{
    color: #000000;
  }
  /* Theme-dark */
  .theme--dark .grid-parner-content::-webkit-scrollbar {
    width: 17px;
  }
  .theme--dark .grid-parner-content::-webkit-scrollbar-track  {
      background-color: #595B64;
  }
  .theme--dark .grid-parner-content::-webkit-scrollbar-thumb {
      background-color: #DEDFE0;
  }
  .theme--dark .grid-parner-content::-webkit-scrollbar-corner{
    background-color: #595B64;
  }
  .theme--dark .partner-card-container{
    background: linear-gradient(to top right,transparent 50%,#191a21 0) top right/25px 26px no-repeat,
    linear-gradient(to bottom left,transparent 50%,#191a21 0) bottom left/25px 26px no-repeat, #191a21;
  }
</style>